module.exports = __webpack_public_path__ + "static/media/chizitelum_oranu.c3143279.png";